import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { VideoGridComponent } from "./video-grid.component";

@Injectable({
    providedIn: 'root',
  })
  
export class VideoGridService {


    // Observable string sources
    private videoGridResizer = new Subject<any>();

    // Observable string streams
    videoGridResizer$ = this.videoGridResizer.asObservable();
    constructor() { }

    resizer() {
        this.videoGridResizer.next();
    }
}
